<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="60%">

    <div>
      <div class='item' v-for="item of configList" :key='item.id'>
        <div class='title'>{{item.label}}</div>
        <el-input class='input' v-model="item.message" placeholder="没填时提示语"></el-input>
        <el-checkbox v-model="item.required"></el-checkbox>

      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="close()">取 消</el-button>
      <el-button type="primary" @click="save()">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getFormConfig, saveFormConfig } from '@/api/race/raceRaise'
export default {
  name: 'FormConfig',
  data() {
    return {
      title: '创建比赛设置',
      type: 'game',
      dialogVisible: false,
      configList: []
    }
  },
  methods: {
    open(type, title) {
      this.type = type
      this.title = title
      this.loadConfig()
      this.dialogVisible = true
    },
    close() {
      this.dialogVisible = false
    },
    loadConfig() {
      getFormConfig(this.type).then(res => {
        this.configList = res.data
      })
    },
    getParams() {
      let params = []
      for (let item of this.configList) {
        params.push({id: item.id, message: item.message, required: item.required})
      }
      return params
    },
    save() {
      saveFormConfig(this.getParams()).then(res => {
        console.log('res', res)
        this.close()
      })
    }
  }
}
</script>

<style scoped lang='less'>
.item{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
  padding-left: 20px;
  .title{
    font-size: 16px;
    margin-right: 30px;
    white-space: nowrap;
    width: 120px;
  }
  .input{
    margin-right: 30px;
    width: 30%;
  }
}
</style>